export const MODAL_TYPE_POST_FORM_EDIT_IN_PROGRESS = 'post-form-edit-in-progress';
export const MODAL_TYPE_ADD_CATEGORIES = 'add-categories';
export const MODAL_TYPE_DISCARD_POST = 'discard-post';
export const MODAL_TYPE_DISCARD_POST_DRAFT = 'discard-post-draft';
export const MODAL_TYPE_MOVE_TO_TRASH = 'move-to-trash';
export const MODAL_TYPE_PREVIEW_POST = 'preview-post';
export const MODAL_TYPE_PROFILE_ACTIONS = 'profile-actions';
export const MODAL_TYPE_PROFILE_ACTIONS_UPPER_PART = 'profile-actions-upper-part';
export const MODAL_TYPE_REPORT_COMMENT = 'report-comment';
export const MODAL_TYPE_REPORT_POST = 'report-post';
export const MODAL_TYPE_REPORT_MEMBER = 'report-member';
export const MODAL_TYPE_SHARE_POST = 'share-post';
export const MODAL_TYPE_SHARE_LINK = 'share-link';
export const MODAL_TYPE_SHARE_COMMENT = 'share-comment';
export const MODAL_TYPE_DEMO_MODE = 'demo-mode';
export const MODAL_POST_FORM_ACTIONS = 'post-form-actions';
export const MODAL_TYPE_POST_SETTINGS = 'post-settings';
export const MODAL_TYPE_DISCARD_POST_SETTINGS = 'discard-post-settings';
export const MODAL_TYPE_RICH_CONTENT_EDITOR = 'rich-content-editor';
export const MODAL_TYPE_REVERT_TO_DRAFT = 'revert-to-draft';
export const MODAL_TYPE_LOADER = 'loader';
export const MODAL_TYPE_IMPORT_WIX_SITE = 'import-wix-posts';
//# sourceMappingURL=modal-types.js.map